import * as constants from './ClassRestriction.constants';
import * as services from './ClassRestriction.service';

const state = {
  classRestriction: {},

  isRequest: false,
};

const mutations = {
  [constants.GET_CLASS_RESTRICTION_SUCCESS](state, classRestriction) {
    if (undefined !== classRestriction && null !== classRestriction) {
      state.classRestriction = classRestriction;
    }
  },

  [constants.SET_IS_REQUEST_STATUS](state, status) {
    state.isRequest = status;
  },
};

const actions = {
  async getClassRestriction({ commit }, payload) {
    commit(constants.SET_IS_REQUEST_STATUS, true);
    const res = await services.getClassRestriction(payload);
    commit(constants.GET_CLASS_RESTRICTION_SUCCESS, res.data.data);
    commit(constants.SET_IS_REQUEST_STATUS, false);
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
